<template>
  <v-app>
    <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
    <router-view v-if="!loading"></router-view>
  </v-app>
</template>

<script>
import { loadLanguageAsync } from "@/plugins/i18n";
import AuthService from "@/services/AuthService";

export default {
  name: "App",
  components: {},
  data() {
    return {
      loading: true
    };
  },
  async beforeCreate() {
    if (this.$store.getters.isLoggedIn) {
      var token = this.$store.state.token;
      await AuthService.profile({
        headers: { Authorization: "Bearer " + token }
      })
        .then(result => {
          this.$store.dispatch("setToken", token);
          this.$store.dispatch("setUser", result.data.user);
        })
        .catch(err => {
          this.error = err.response.data.error;
          this.$store.dispatch("logout");
          this.$router.push({ name: "Home" });
        });
    }
  },
  created: function() {
    loadLanguageAsync("en").then(() => {
      this.loading = false;
    });
  },
  methods: {}
};
</script>

<style>
body {
  font-family: "Poppins", sans-serif;
}
.v-application .v-alert__content .blue--text {
  color: #eee !important;
}
.main {
  max-width: 1380px;
  margin: 0 auto;
}
.swal-modal {
  background-color: #00264c;
}
.swal-title,
.swal-text {
  color: #f1f5f9;
}
.swal-button:focus {
  outline: none;
  box-shadow: none;
}
.swal-icon--success::after,
.swal-icon--success::before {
  background-color: #00264c;
}
.swal-icon--success__hide-corners {
  background-color: #00264c;
}
.swal-close {
  background-color: #f4511e;
}
.swal-close:hover {
  background-color: #bf360c !important;
}
body .v-btn-toggle > .v-btn.v-btn {
  opacity: 1;
}
.container1400 {
  max-width: 1380px !important;
  margin: 0 auto;
  width: 100%;
}
.container-ml-0 {
  max-width: 1380px !important;
}
.full-header .container1400 {
  max-width: none !important;
}
.v-list-item--dense .v-list-item__title {
  text-transform: capitalize;
}
.swal-modal.custom-confirm .swal-footer {
  margin: 0;
}
.swal-modal.custom-confirm .swal-button--cancel {
  background-color: #0080ff;
  color: #fff;
  min-width: 100px;
}
.swal-modal.custom-confirm .swal-button--confirm {
  background-color: #f44336;
  min-width: 100px;
}
.row {
  margin: -12px;
}
</style>
